import { Button, StatusBadge } from "@swot/base-components";
import { FiBell } from "react-icons/fi";

export function CmtsNotificationBell(props: {
  unreadCount: number;
  criticalCount?: number | undefined;
  onClick: () => void;
}) {
  const hasUnread = props.unreadCount > 0;
  const label = `Open notifications${hasUnread ? `, ${props.unreadCount} unread` : ""}`;

  return (
    <span className={hasUnread ? "cmts-notification-bell cmts-notification-bell--active" : "cmts-notification-bell"}>
      <Button
        intent="button"
        className="cmts-notification-bell__button"
        aria-label={label}
        onClick={props.onClick}
        title="Open notification center"
      >
        <FiBell aria-hidden="true" />
      </Button>

      {hasUnread ? (
        <StatusBadge
          label={props.unreadCount > 99 ? "99+" : String(props.unreadCount)}
          tone="info"
          className="cmts-notification-bell__badge"
        />
      ) : null}

      {(props.criticalCount ?? 0) > 0 ? (
        <StatusBadge
          label="Critical"
          tone="danger"
          className="cmts-notification-bell__critical"
        />
      ) : null}
    </span>
  );
}